import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import managedItHero from "../assets/Hero/managed-hero.jpeg"; // Replace with your hero image
import itSupportImage from "../assets/Hero/managed.jpg"; // Replace with your IT Support image
import networkManagementImage from "../assets/Hero/network_infrastructure.jpg"; // Replace with your Network Management image
import cybersecurityImage from "../assets/Hero/Cloud-Optimization.jpg"; // Replace with your Cybersecurity image
import "../assets/css/managedItPage.css";

// Register the ScrollTrigger plugin
gsap.registerPlugin(ScrollTrigger);

// JSON data for headings and paragraphs
const managedItData = {
  hero: {
    title: "Managed IT Services",
    subtitle: "Comprehensive IT Solutions to Keep Your Business Running Smoothly",
  },
  introduction: {
    heading: "Why Managed IT Services Matter",
    paragraphs: [
      "Managed IT services provide businesses with proactive IT support, ensuring minimal downtime and maximum productivity.",
      "Our managed IT services include IT support, network management, cybersecurity, and more, tailored to meet your business needs.",
    ],
  },
  services: [
    {
      name: "IT Support",
      image: itSupportImage,
      description: "24/7 IT support to resolve issues quickly and keep your systems running efficiently.",
    },
    {
      name: "Network Management",
      image: networkManagementImage,
      description: "Expert management of your network infrastructure to ensure reliability and performance.",
    },
    {
      name: "Cybersecurity",
      image: cybersecurityImage,
      description: "Advanced cybersecurity solutions to protect your business from threats and vulnerabilities.",
    },
  ],
  cta: {
    heading: "Ready to Optimize Your IT Infrastructure?",
    text: "Contact us today to learn more about our Managed IT Services and how we can help your business thrive.",
  },
};

export const ManagedItPage = ({ data }) => {
  const managedItRef = useRef(null);
  const navigate = useNavigate(); // Initialize useNavigate

  useEffect(() => {
    const elements = managedItRef.current.querySelectorAll(".managed-it-animate");

    gsap.fromTo(
      elements,
      { y: 100, opacity: 0 },
      {
        y: 0,
        opacity: 1,
        duration: 1.0,
        ease: "power3.out",
        stagger: 0.2,
        scrollTrigger: {
          trigger: managedItRef.current,
          start: "top 80%",
          toggleActions: "play none none reset",
        },
      }
    );
  }, []);

  // Function to handle navigation
  const handleContactClick = () => {
    navigate("/contact"); // Navigate to the contact page
  };

  return (
    <div className="managed-it-page" ref={managedItRef}>
      {/* Hero Section */}
      <div
        className="managed-it-hero-section"
        style={{ backgroundImage: `url(${managedItHero})` }}
      >
        <h1 className="managed-it-animate">{managedItData.hero.title}</h1>
        <p className="managed-it-animate">{managedItData.hero.subtitle}</p>
      </div>

      {/* Introduction Section */}
      <div className="managed-it-introduction">
        <h2 className="managed-it-animate">{managedItData.introduction.heading}</h2>
        {managedItData.introduction.paragraphs.map((paragraph, index) => (
          <p key={index} className="managed-it-animate">
            {paragraph}
          </p>
        ))}
      </div>

      {/* Services Section */}
      <div className="managed-it-services-list">
        {managedItData.services.map((service, index) => (
          <div key={index} className="service-card managed-it-animate">
            <img
              src={service.image}
              className="service-image"
              alt={service.name}
            />
            <h3>{service.name}</h3>
            <p>{service.description}</p>
          </div>
        ))}
      </div>

      {/* Call to Action Section */}
      {/* <div className="managed-it-cta">
        <h2 className="managed-it-animate">{managedItData.cta.heading}</h2>
        <p className="managed-it-animate">{managedItData.cta.text}</p>
        <button
          className="btn btn-primary managed-it-animate"
          onClick={handleContactClick}
        >
          Contact Us
        </button>
      </div> */}
    </div>
  );
};